import { match } from 'path-to-regexp'

export const isMatch = (pathname: string, urls: string[]) => {
  return urls.some(url => !!match(url)(pathname))
}
